/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cross': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M5.998 11.14h-.012a.856.856 0 100 1.714h12.02a.856.856 0 100-1.714H5.998z" _fill="#303030"/><path pid="1" d="M12.853 5.998v-.012a.856.856 0 10-1.713 0V18.007a.856.856 0 101.713 0v-.014.002V5.997z" _fill="#303030"/><path pid="2" d="M11.996 0C5.381 0 0 5.382 0 11.996c0 6.615 5.382 11.996 11.996 11.996 6.615 0 11.996-5.382 11.996-11.996C23.992 5.381 18.61 0 11.996 0zm0 1.714a10.27 10.27 0 0110.283 10.283 10.27 10.27 0 01-10.283 10.282A10.27 10.27 0 011.713 11.997 10.27 10.27 0 0111.996 1.714z" _fill="#303030"/>'
  }
})
